import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {
  Box,
  Button,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material';
import { DialogDefaultV2 } from '../../../../components/v2';

const NsirMapaGpsDialog = ({ open, onClose, nsirsInvalidas }) => {
  const hasNsirErrors = nsirsInvalidas.length > 0;

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={onClose}
      handlerConfirm={onClose}
      title="Inconsistências de localização"
      cancelMessage="Fechar"
      maxWidth="sm"
      fullWidth
      readOnly
    >
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Estes registros não puderam ser plotados porque os dados de GPS estão inconsistentes ou fora da área de atuação.
      </Typography>

      {hasNsirErrors ? (
        <>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            NSIRs ({nsirsInvalidas.length})
          </Typography>
          <List dense disablePadding>
            {nsirsInvalidas.map((item) => (
              <ListItem
                key={item.id}
                divider
                secondaryAction={
                  <Button
                    size="small"
                    component={Link}
                    to={`/nsir/${item.id}`}
                    target="_blank"
                  >
                    Corrigir
                  </Button>
                }
              >
                <ListItemText
                  primary={`Código: ${item.codigo}`}
                  secondary={`Motivo: ${item.motivo} | Lat: ${item.latitude} Lng: ${item.longitude}`}
                />
              </ListItem>
            ))}
          </List>
        </>
      ) : (
        <Box sx={{ py: 2 }}>
          <Typography variant="body2" color="text.secondary">
            Nenhuma inconsistência detectada.
          </Typography>
        </Box>
      )}
    </DialogDefaultV2>
  );
};

NsirMapaGpsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  nsirsInvalidas: PropTypes.array.isRequired,
};

export default NsirMapaGpsDialog;
